<template>
    <div>

        <config-main-title>
            Sociedades
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Sociedade
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma Sociedade identificada.'" 
                icon="fas fa-search"
                :action="'Incluir Sociedade'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span v-if="dado.fl_recorrente" class="text-muted"
                            data-toggle="tooltip" data-placement="top" title="Recorrente"> 
                            <i class="fas fa-sync"></i>
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_sociedade_medica ? '' : 'Nova' }}
                            Sociedade
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Informe o nome da sociedade..."
                                    label="Nome"
                                    :validate="validate"
                                    required
                                    v-model="item.st_sociedade_medica" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Percentual da Receita"
                                    type="money"
                                    :validate="validate"
                                    required
                                    v-model="item.dc_percentual_receita" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Distribuição Societária"
                                    type="select"
                                    :optionsList="[
                                        {id: 'F', search: 'Fixo'},
                                        {id: 'V', search: 'Variável'},
                                        {id: 'P', search: 'Produção'},
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="item.st_tipo_distribuicao" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    placeholder="Centro de Custo..."
                                    label="Centro de Custo"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsData="id_centro_custo"
                                    service="centro_custos.index"
                                    :optionsSync="false"
                                    :validate="validate"
                                    v-model="item.id_centro_custo" />
                            </div>

                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" title="Filtros da Composição da Receita" />

                        <!-- Cotistas -->
                        <az-sub-title title="Cotistas">
                            <span v-if="item.st_tipo_distribuicao == 'F' && item.sociedade_medica_cotistas.filter(ic => !ic.excluido).length"
                                class="mr-3">
                                {{ 
                                    $util.formatMoeda(
                                        item.sociedade_medica_cotistas.filter(ic => !ic.excluido).reduce((total, carry) => { 
                                            return total + carry.dc_percentual_fixo;
                                        }, 0)
                                    )
                                }}%
                            </span>
                            <a href="#" @click.prevent="incluir_cotista(item)">
                                <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                Incluir Cotista
                            </a>
                        </az-sub-title>
                        <div class="row" v-for="(cotista, icx) in item.sociedade_medica_cotistas.filter(ic => !ic.excluido)" :key="icx">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    sizing="sm"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="medicos.index"
                                    required
                                    :validate="validate"
                                    v-model="cotista.medico"
                                    icon="fa fa-minus"
                                    :buttonIcon="true"
                                    buttonText="fa fa-minus"
                                    buttonColor="outline-danger"
                                    @clickButton="cotista.excluido = true" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="item.st_tipo_distribuicao == 'F'">
                                <az-input
                                    sizing="sm"
                                    icon="fa fa-percent"
                                    type="number"
                                    required
                                    v-model="cotista.dc_percentual_fixo" />
                            </div>
                        </div>
                        <div v-if="!item.sociedade_medica_cotistas.filter(ic => !ic.excluido).length">
                            Nenhum cotista relacionado.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="sociedadeMedica" :id="item.id_sociedade_medica" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_sociedade_medica ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel,
        AzSubTitle,
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade'});
            }
            
            return opcoes;
        }
    },

    methods: { 
        incluir_cotista(item) { 
            item.sociedade_medica_cotistas.push({ 
                id_sociedade_medica_filtro: null, 
                id_sociedade_medica: item.id_sociedade_medica,
                id_medico: "",
                dc_percentual_fixo: 0,
                excluido: false, 
                medico: null, 
            });
        }, 

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },
        incluir_filtro(item) { 
            item.filtros.push({ 
                id_teto_atendimento_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },
        incluir () { 
            this.validate = false;

            let item = {
                id_sociedade_medica: null, 
                st_sociedade_medica: "",
                fl_ativo: true,
                dc_percentual_receita: 0,
                st_tipo_distribuicao: "F",
                filtros: [],
                sociedade_medica_cotistas: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'sociedades_medicas',
                func: 'index',
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'sociedades_medicas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'sociedades_medicas',
                dados: item,
            });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Repasse", path: "/repasse/visao"},
                { name: "Sociedades", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>